module.exports = __webpack_public_path__ + "static/media/video-icon.a08cc672.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/video-icon.svg
// module id = 1036
// module chunks = 0